import React from 'react';
import {red50} from "../../../../../assets/jss/main";

function SidebarDesktopContainer(props) {
    const isPreprodOrSandbox = ['preprod', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT)

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height:' 100%',
            position: 'fixed',
            width: '240px',
            maxWidth: '240px',
            backgroundColor: isPreprodOrSandbox ? red50 : "transparent"
        }}>
            {props.children}
        </div>
    );
}

export default SidebarDesktopContainer;
